import React from 'react';

export default function OutlookLinkedText() {
  return (
    <>
      <p>
        <b>MS Office 365</b>
        {' '}
        account is linked.
      </p>
      <p>Disconnect your account by clicking the MS Office 365 button.</p>
    </>
  );
}
